<template lang="pug">
#bloco-resumo-contrato-originacao
    el-card(shadow='never', :body-style='{ padding: "0px" }')
        .bloco-resumo-contrato-originacao__coluna-esquerda
            .bloco-resumo-contrato-originacao__cabecalho
                p {{ $t('mensagens.subEmpresaGestao.blocoresumocontratooriginacao.resumo') }}
                p {{ $t('mensagens.subEmpresaGestao.blocoresumocontratooriginacao.total') }}

            .bloco-resumo-contrato-originacao__linha
                p {{ $t('mensagens.subEmpresaGestao.blocoresumocontratooriginacao.volumeContrado') }}
                p {{ resumo.volumeContratado }}

            .bloco-resumo-contrato-originacao__linha
                p {{ $t('mensagens.subEmpresaGestao.blocoresumocontratooriginacao.volumeElegivel') }}
                p {{ resumo.volumeInseridoSemRestricao }}

            .bloco-resumo-contrato-originacao__linha
                p {{ $t('mensagens.subEmpresaGestao.blocoresumocontratooriginacao.volumeTotalAtencao') }}
                p(
                    :class='resumo.volumeComRestricoes > 0 ? "bloco-resumo-contrato-originacao__valor--com-restricao" : ""'
                ) {{ resumo.volumeComRestricoes }}

            .bloco-resumo-contrato-originacao__linha
                p {{ $t('mensagens.subEmpresaGestao.blocoresumocontratooriginacao.saldo') }}
                p {{ resumo.saldo ?? resumo.saldoRestante }}

        .bloco-resumo-contrato-originacao__coluna-direita
            .bloco-resumo-contrato-originacao__cabecalho
                p {{ $t('mensagens.subEmpresaGestao.blocoresumocontratooriginacao.resumo') }}
                p {{ $t('mensagens.subEmpresaGestao.blocoresumocontratooriginacao.total') }}

            .bloco-resumo-contrato-originacao__linha
                p {{ $t(this.usuarioLogado.ambienteLogado === 'PY' ? 'mensagens.subEmpresaGestao.blocoresumocontratooriginacao.numeroFincasInseridos' : this.usuarioLogado.ambienteLogado === 'AR' ? 'mensagens.subEmpresaGestao.blocoresumocontratooriginacao.numeroTerritoriosInseridosAR' : 'mensagens.subEmpresaGestao.blocoresumocontratooriginacao.numeroCarsInseridos') }}
                p {{ resumo.territoriosInseridos }}

            .bloco-resumo-contrato-originacao__linha
                p
                    i.flow.flow-verified.verde.mr-2
                    | {{  $t(this.ambienteLogadoPY ? 'mensagens.subEmpresaGestao.blocoresumocontratooriginacao.numeroFincasElegiveis' : this.usuarioLogado.ambienteLogado === "AR" ? 'mensagens.subEmpresaGestao.blocoresumocontratooriginacao.numeroTerritoriosElegiveisAR' : 'mensagens.subEmpresaGestao.blocoresumocontratooriginacao.numeroCarsElegiveis')  }}
                p {{ resumo.territoriosConformes }}

            .bloco-resumo-contrato-originacao__linha
                p
                    i.flow.flow-warning-sign.mr-2
                    | {{  $t(this.ambienteLogadoPY ? 'mensagens.subEmpresaGestao.blocoresumocontratooriginacao.numeroFincasComAlerta' : this.usuarioLogado.ambienteLogado === "AR" ? 'mensagens.subEmpresaGestao.blocoresumocontratooriginacao.numeroTerritoriosComAlertaAR' : 'mensagens.subEmpresaGestao.blocoresumocontratooriginacao.numeroCarsComAlerta')  }}
                p {{ resumo.territorioComAlertas }}

            .bloco-resumo-contrato-originacao__linha
                p
                    i.mdi.mdi-information-outline
                    | {{  $t(this.ambienteLogadoPY ? 'mensagens.subEmpresaGestao.blocoresumocontratooriginacao.numeroFincasInelegiveis' : this.usuarioLogado.ambienteLogado === "AR" ? 'mensagens.subEmpresaGestao.blocoresumocontratooriginacao.numeroTerritoriosInelegiveisAR' : 'mensagens.subEmpresaGestao.blocoresumocontratooriginacao.numeroCarsInelegiveis')  }}
                p {{ resumo.territoriosInConformes }}
</template>

<script>
import { mapGetters } from 'vuex';

export default {
    name: 'BlocoResumoContratoOriginacao',

    props: {
        resumo: {
            required: true,
            type: Object
        }
    },

    data() {
        return {};
    },

    computed: {
        ...mapGetters(['usuarioLogado']),
        ambienteLogadoPY() {
            return this.usuarioLogado.ambienteLogado === 'PY';
        }
    },

    methods: {}
};
</script>

<style lang="scss">
#bloco-resumo-contrato-originacao {
    .bloco-resumo-contrato-originacao__linha,
    .bloco-resumo-contrato-originacao__cabecalho {
        display: flex;
        justify-content: space-between;
        padding: 8px 16px;

        p {
            margin-bottom: 0px;
        }
    }

    .bloco-resumo-contrato-originacao__coluna-esquerda,
    .bloco-resumo-contrato-originacao__coluna-direita {
        width: 50%;
    }

    .bloco-resumo-contrato-originacao__coluna-esquerda {
        border-right: 1px solid var(--gray);
    }

    .bloco-resumo-contrato-originacao__cabecalho {
        font-weight: bold;
        border-bottom: 1px solid var(--gray);
    }

    .bloco-resumo-contrato-originacao__linha p {
        display: flex;
        align-items: center;
    }

    .bloco-resumo-contrato-originacao__linha:nth-child(odd) {
        background-color: var(--list-background-contrast);
    }

    .bloco-resumo-contrato-originacao__valor--com-restricao {
        color: var(--danger);
    }

    .el-card__body {
        display: flex;
    }

    .flow.flow-warning-sign.mr-2 {
        color: var(--warning);
    }

    .mdi-information-outline {
        color: var(--danger);
        font-size: 17px;
        margin-right: 4px;
        height: 17px;
        margin-top: -8px;
    }
}
</style>
